import { render, staticRenderFns } from "./RunnitSelectedVideo.vue?vue&type=template&id=40b967c6&scoped=true"
import script from "./RunnitSelectedVideo.vue?vue&type=script&lang=ts"
export * from "./RunnitSelectedVideo.vue?vue&type=script&lang=ts"
import style0 from "./RunnitSelectedVideo.vue?vue&type=style&index=0&id=40b967c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b967c6",
  null
  
)

export default component.exports